import { CurrencyEnum } from '@systemeio/ui'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'

export const hasChartValues = (currencies: CurrencyEnum[], values: AffiliateSumType) =>
  currencies.some(cur => values[cur] !== 0 && values[cur] !== undefined)
